import { useMutation } from "@tanstack/react-query";
import { getLocationReport, getMonitoringReport, getPlantReport, getPlantationReport, getPlottingReport } from "~/services/report.service";

export function usefetchPlantReport() {
    return useMutation((payloads) => getPlantReport(payloads));
}
  
export function usefetchLocationReport() {
    return useMutation((payloads) => getLocationReport(payloads));
}

export function userfetchPlottingReport() {
    return useMutation((payloads) => getPlottingReport(payloads));
}

export function usefetchPlantationReport() {
    return useMutation((payloads) => getPlantationReport(payloads));
}

export function usefetchMonitoringReport() {
    return useMutation((payloads) => getMonitoringReport(payloads));
}
